export const colors = {
  green: '#61c876',
  green5: '#5CBE70',
  green40: '#4EA05E',
  green50: '#B0E4BB',
  green60: '#DBF6E0',
  green90: '#EFF9F1',

  red: '#F65540',

  yellow: '#FFC700',
  orange: '#FFA34E',

  navy: '#30435A',
  grey40: '#838E9C',
  grey80: '#D6D9DE',
  grey90: '#EAECEE',
  grey95: '#F5F6F7',

  white: '#ffffff',
  black: '#000000',
};
